import type { DistrictOption, ZipCodeEntry } from '@/types-district-catalog';

interface RawCatalog {
  byDistrict: Record<string, ZipCodeEntry[]>;
}

function buildDistrictCatalog(raw: RawCatalog): DistrictOption[] {
  return Object.entries(raw.byDistrict)
    .map(([districtName, entries]) => ({
      id: districtName,
      label: districtName,
      canton: entries[0]?.canton ?? '',
      postcodes: [...new Set(entries.map((e) => e.postalCode))],
      entries,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

/**
 * Zip code catalog JSON is chosen by deployment stage (`VUE_APP_STAGE` from set-env).
 * Only `prod` uses the production export; all other stages use the test snapshot.
 */
export async function fetchDistrictCatalog(): Promise<DistrictOption[]> {
  const { default: zipCodeData } =
    import.meta.env.VUE_APP_STAGE === 'prod'
      ? await import('@/assets/data/ZipCode_byDistrict_prod.json')
      : await import('@/assets/data/ZipCode_byDistrict_test.json');
  return buildDistrictCatalog(zipCodeData as unknown as RawCatalog);
}
